// The words a table says (DataTable, its View and Columns menus, Copy and CSV), so the vendor portal can say them in
// 中文 too (web/src/portal/strings.ts gives its own). The staff app uses these, as they've always read.
import { createContext, useContext } from "react";

export const TABLE_TEXT = {
  defaultView: "Default view",
  changed: "changed",
  viewsTitle: "Switch between your views of this table",
  changedTitle: (name: string) => `${name}, changed: save it, save it as a new view, or discard the changes`,
  viewsHint: "Your views of this table: columns, widths, sort and filters",
  differs: (name: string | null) => (name ? `The table differs from “${name}”.` : "The table differs from the default."),
  saveTo: (name: string) => `Save to “${name}”`,
  saveAsNew: "Save as a new view…",
  saveAsLabel: "Save what the table shows now as a view",
  rename: "Rename",
  renameLabel: (name: string) => `Rename “${name}”`,
  remove: (name: string) => `Delete “${name}”`,
  discard: "Discard changes",
  namePlaceholder: "Late from Tailhoo",
  nameHint: "Enter saves · Esc goes back",
  columns: "Columns",
  hidden: (n: number) => ` (${n} hidden)`,
  columnsTitle: "Choose the columns this table shows; drag a column's header to move it, its edge to resize it",
  columnsHint: "Drag a header to move a column, its edge to resize it.",
  showAll: "Show them all",
  reset: "Reset widths and order",
  copy: "Copy",
  copyTitle: "Copy this table (as filtered and sorted) to paste into Google Sheets or Excel",
  copied: (n: number) => `Copied ${n.toLocaleString()} rows: paste into a sheet`,
  copyFailed: "The browser didn't allow copying; use CSV instead",
  csvTitle: "Download this table (as filtered and sorted) as a CSV file",
  of: (shown: string, all: string) => `${shown} of ${all}`,
  editHint: "Click a blue column to edit · Enter saves and moves down · Tab moves across · Esc cancels",
  selectAll: (n: number) => `Select all ${n}`,
  clearSelection: "Clear selection",
  selectRow: "Select this row",
  filter: "Filter…",
  total: "Total",
};
export type TableText = typeof TABLE_TEXT;

export const TableTextContext = createContext<TableText>(TABLE_TEXT);
export const useTableText = () => useContext(TableTextContext);
